// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy .image-wrapper{clear:both;margin-bottom:1rem}.privacy-policy .image-wrapper img{width:120px;margin-left:1rem;float:right}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/routes/privacy.vue"],"names":[],"mappings":"AAEC,+BACC,UAAA,CACA,kBAAA,CAEA,mCACC,WAAA,CACA,gBAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
